import { Component, Input } from '@angular/core';
import { ElementComponent } from '../element-wyswyg/element-wyswyg.component';

@Component({
  selector: 'app-list-rendered',
  templateUrl: './list-rendered.component.html',
  styleUrls: ['./list-rendered.component.css']
})
export class ListRenderedComponent  extends ElementComponent {
  @Input() override data: any = {
    list: [
      'Elemento 0',
    ],
    ordered: false,
    startList: 1,
    mark: "circle",
    indent: 0
  };
}
